import React, { useEffect, useState } from "react";
import SellerSidebar from "./common/SellerSidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import CommanPagination from "../pages/common/CommanPagination/CommanPagination";
import ProfileSidebar from "../pages/common/ProfileSidebar";

function Order() {
  const { orderId } = useParams();
  const [orders, setOrders] = useState(() => {
    const base = [
      {
        product: "Woolen Clothes for elders",
        date: "Aug, 28 2024 02:28:22 PM",
        amount: "200.00 USD",
      },
      {
        product: "Medical supplies for rural clinic",
        date: "Aug, 29 2024 11:05:10 AM",
        amount: "150.00 USD",
      },
      {
        product: "Blankets for winter drive",
        date: "Sep, 02 2024 04:45:18 PM",
        amount: "120.00 USD",
      },
    ];
    const payments = ["Card", "Bank", "QR"];
    const statuses = [
      "Confirmed",
      "Pending",
      "Confirmed",
      "Confirmed",
      "Pending",
    ];
    const temp = [];
    for (let i = 1; i <= 25; i++) {
      const b = base[i % base.length];
      temp.push({
        id: i,
        product: b.product,
        date: b.date,
        quantity: (i % 5) + 1,
        amount: b.amount,
        payment: payments[i % payments.length],
        status: statuses[i % statuses.length],
      });
    }
    return temp;
  });

  // Hooks for table functionality
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [filterStatus, setFilterStatus] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const navigate = useNavigate();

  const handleEdit = (orderId) => {
    navigate(`/orders/order-detail/${orderId}`);
  };

  const handleDelete = (orderId) => {
    setOrders((prev) => prev.filter((o) => o.id !== orderId));
  };

  // Sorting function
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  // Filter orders based on status and search
  const filteredOrders = orders.filter((order) => {
    const statusMatch =
      filterStatus === "all"
        ? true
        : order.status.toLowerCase() === filterStatus.toLowerCase();
    const search = searchQuery.trim().toLowerCase();
    const searchMatch =
      search === ""
        ? true
        : order.product.toLowerCase().includes(search) ||
          String(order.id).includes(search);
    return statusMatch && searchMatch;
  });

  // Sort orders
  const sortedOrders = [...filteredOrders].sort((a, b) => {
    if (sortConfig.key) {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === "asc" ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === "asc" ? 1 : -1;
      }
    }
    return 0;
  });

  // Pagination
  const totalCounts = sortedOrders.length;
  const totalPage = Math.max(1, Math.ceil(totalCounts / limit));
  const startIndex = (currentPage - 1) * limit;
  const currentOrders = sortedOrders.slice(startIndex, startIndex + limit);

  useEffect(() => {
    // Reset to first page when filters/search change
    setCurrentPage(1);
  }, [filterStatus, searchQuery, limit]);

  return (
    <>
      <div className="all_suport_bg manages_top">
        <section className="ser_v_araeea profiles">
          <div className="container">
            <div className="bradcams">
              <span className="bothss">
                <Link to="">Dashboard</Link>{" "}
                <img src="/images/brd_rowwo.png" alt="" /> Store
                <img src="/images/brd_rowwo.png" alt="" /> Orders
              </span>
            </div>
            <div className="row">
              <div className="col-lg-3 mb_view_hide">
                <SellerSidebar />
              </div>

              <div className="col-lg-9 order-list">
                {/* Search and Filter */}
                <div
                  className="d-flex justify-content-end align-items-center mb-3"
                  style={{ gap: "12px" }}
                >
                  {/* Left: Search + Filter */}
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "8px" }}
                  >
                    <div
                      className=""
                      style={{ position: "relative", width: "250px" }}
                    >
                      <input
                        type="text"
                        className="search-input "
                        placeholder="Search"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                      <img
                        src="/images/search.png"
                        alt="search"
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          width: "25px",
                          height: "24px",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                    <button className="btn-filter">
                      <img src="/images/controls-alt.png" alt="filter" />
                    </button>
                  </div>
                </div>

                {/* Order List */}
                <div className="form_boxx profilss">
                  <div className="form_arar mt-0">
                    <h5>Order List</h5>

                    {/* Scroll wrapper */}
                    <div style={{ overflowX: "auto" }}>
                      <table className="orders-table">
                        <thead>
                          <tr className="table-header">
                            <th className="header-cell">S. No.</th>
                            <th className="header-cell">Product Name</th>
                            <th className="header-cell">Date</th>
                            <th className="header-cell">Quantity</th>
                            <th className="header-cell">Amount</th>
                            <th className="header-cell">Payment</th>
                            <th className="header-cell">Status</th>
                            <th className="header-cell">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentOrders.map((order, index) => (
                            <tr key={order.id} className="table-row">
                              <td className="table-cell serial-number">
                                {(currentPage - 1) * limit + index + 1}.
                              </td>
                              <td className="table-cell product-name">
                                {order.product}
                              </td>
                              <td className="table-cell date">{order.date}</td>
                              <td className="table-cell quantity">
                                {order.quantity.toString().padStart(2, "0")}
                              </td>
                              <td className="table-cell amount">
                                {order.amount}
                              </td>
                              <td className="table-cell payment">
                                {order.payment}
                              </td>
                              <td
                                className={`table-cell status ${order.status.toLowerCase()}`}
                              >
                                {order.status}
                              </td>
                              <td className="table-cell action">
                                <div className="flexx" style={{ gap: "10px" }}>
                                  <img
                                    className="action-btn edit-btn"
                                    src="/images/edit_views.png"
                                    alt="edit"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleEdit(order.id)}
                                  />
                                  <img
                                    className="action-btn delete-btn"
                                    src="/images/ic_delets.png"
                                    alt="delete"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleDelete(order.id)}
                                  />
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {/* Pagination */}
                <div className="pages_liststs">
                  <CommanPagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    limit={limit}
                    totalCounts={totalCounts}
                    totalPage={totalPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Order;
